<template>
  <section class="welfare-card" aria-label="晋级彩金记录">
    <div class="history-heading"><h2>晋级彩金记录</h2><button type="button" :disabled="loading" @click="load(true)">刷新</button></div>
    <p v-if="error" class="welfare-error">{{ error }}</p>
    <p v-else-if="loading && !records.length">记录加载中…</p>
    <p v-else-if="!records.length">暂无晋级彩金记录</p>
    <article v-for="record in records" :key="record.id" class="history-row">
      <div><b>{{ record.title }}</b><span>{{ statusText[record.status] || '状态待核对' }}</span></div>
      <p>彩金金额：{{ record.amount }}</p>
      <small>申请时间：{{ formatTime(record.appliedAt) }}</small>
      <small v-if="record.completedAt">完成时间：{{ formatTime(record.completedAt) }}</small>
    </article>
    <button v-if="records.length < total" type="button" :disabled="loading" @click="load(false)">加载更多</button>
  </section>
</template>

<script setup>
import { onBeforeUnmount, ref, watch } from 'vue'
import { webApi } from '../../services/webApi'
import { authStorage } from '../../services/http'

const props = defineProps({ refreshKey: { type: Number, default: 0 } })
const records = ref([])
const total = ref(0)
const loading = ref(false)
const error = ref('')
const statusText = { 0: '未派发', 1: '派发中', 2: '已派发', 3: '已取消', 4: '被拦截', 10: '被拦截' }
let pageNumber = 0
let sequence = 0
let disposed = false

function formatTime(value) { return value ? new Date(Number(value) * 1000).toLocaleString('zh-CN') : '—' }
async function load(reset = true) {
  if (!reset && loading.value) return
  const version = ++sequence
  const token = authStorage.getToken()
  const nextPage = reset ? 1 : pageNumber + 1
  loading.value = true
  error.value = ''
  if (reset) { records.value = []; total.value = 0; pageNumber = 0 }
  try {
    const result = await webApi.vipBonuses({ pageNumber: nextPage, pageSize: 10 })
    if (disposed || version !== sequence || token !== authStorage.getToken()) return
    if (!Array.isArray(result?.data)) throw new Error('记录返回格式错误')
    records.value = reset ? result.data : [...records.value, ...result.data]
    total.value = Number(result.total || 0)
    pageNumber = nextPage
  } catch (loadError) {
    if (!disposed && version === sequence && token === authStorage.getToken()) error.value = loadError.message || '记录查询失败，请重试'
  } finally { if (!disposed && version === sequence) loading.value = false }
}
watch(() => props.refreshKey, () => load(true), { immediate: true })
onBeforeUnmount(() => { disposed = true; sequence += 1 })
</script>

<style scoped>
.history-heading, .history-row > div { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.history-heading h2 { margin-bottom: 0; }
.history-heading { margin-bottom: 20px; }
.history-row { padding: 18px 0; border-top: 1px solid #e7ecf3; }
.history-row p { margin: 10px 0; }
.history-row small { display: block; margin-top: 6px; color: #64748b; }
</style>
